import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-invoice-03',
  standalone: true,
  templateUrl: '../../assets/invoice-03.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamInvoice03Icon {}
